import { useEffect } from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import { trackClick } from 'utils/tracking';
import { TRACKING_ROUTE_CONFIG } from 'utils/constants/trackingRoutes';

const getPageName = (pathname) => {
  const currentRoute = TRACKING_ROUTE_CONFIG.find(route => 
    matchPath({ path: route.path, end: true }, pathname)
  );
  return currentRoute ? currentRoute.pageName : pathname;
};

const TrackClick = () => {
  const location = useLocation();

  useEffect(() => {
    const handleGlobalClick = (event) => {
      // Find the closest clickable element
      const target = event.target.closest('button, a, [role="button"], .clickable');
      
      if (target) {
        // Try to get a meaningful name for the component
        const componentName = 
          target.getAttribute('data-tracking-name') || 
          target.getAttribute('aria-label') || 
          target.name || 
          target.innerText?.trim()?.substring(0, 30) || 
          'UNKNOWN_COMPONENT';

        const sourcePage = getPageName(location.pathname);

        // Clean up the component name for tracking
        const cleanedName = componentName
          .toUpperCase()
          .replace(/\s+/g, '_')
          .replace(/[^A-Z0-9_]/g, '');

        if (cleanedName && cleanedName !== 'UNKNOWN_COMPONENT') {
          trackClick(sourcePage, cleanedName);
        }
      }
    };

    document.addEventListener('click', handleGlobalClick, true);
    return () => document.removeEventListener('click', handleGlobalClick, true);
  }, [location.pathname]);

  return null;
};

export default TrackClick;
